import { render, staticRenderFns } from "./updateWbxm.vue?vue&type=template&id=607888b8&"
import script from "./updateWbxm.vue?vue&type=script&lang=js&"
export * from "./updateWbxm.vue?vue&type=script&lang=js&"
import style0 from "./updateWbxm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports